import { Component } from 'react';
import {connect} from 'react-redux';
import ConfirmPopup from '../../common/confirm-popup';
import ArrowButton from '../../common/button-arrow';
import {resetPrivacyPolicyForAllUsers} from '../../../actions/users';

class ResetPrivacyPolicyButton extends Component {
  state = {
    popup: false
  };

  resetPrivacyPolicy() {
    this.setState({popup: true});
  }

  handleAction(confirm) {
    const {dispatch} = this.props;

    if (confirm) {
      dispatch(resetPrivacyPolicyForAllUsers())
        .then(() => {
          this.setState({popup: false});
        });
    } else {
      this.setState({popup: false});
    }
  }

  render() {
    const {popup} = this.state;

    return (
      <div>
        <ArrowButton
          arrow={false}
          onClick={() => this.resetPrivacyPolicy()}
        >
          RESET PRIVACY POLICY FOR ALL USERS
        </ArrowButton>
        {
          popup && (
            <ConfirmPopup
              header="Reset privacy policy acceptance for all users"
              onClose={this.handleAction.bind(this)}
            >
              <p>
                You are about to reset privacy policy acceptance for all users. If you continue, all users will be
                required to accept the new version of the privacy policy.
              </p>
            </ConfirmPopup>
          )}

      </div>
    );
  }
}

export default connect()(ResetPrivacyPolicyButton);
